import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { FiltersConfiguration } from '@/modules/ColorModule/helpers/ColorModuleHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MandatoryColorModuleFilters',
  props: {
    filters: null,
    activeTab: null,
    requestFiltersActive: { type: Boolean },
    showLatestColors: { type: Boolean, default: false }
  },
  emits: ['filterChange'],
  setup(__props: any, { emit }) {

const props = __props as { filters: any, activeTab: string, requestFiltersActive: boolean, showLatestColors: boolean };




const mandatoryFiltersConfiguration = computed(() => FiltersConfiguration.filter(
    (filter) => filter.isMandatory && filter.isActive(props.activeTab),
));

const isFilterDisabled = (filter: any): boolean => {
    const isFilterActive = filter.isActive(props.activeTab);
    const isColorTableActive = props.activeTab === 'color-search';
    const isShowingLatestColors = props.showLatestColors;

    return !isFilterActive || (isShowingLatestColors && isColorTableActive);
};

const onFilterChange = (value: string, type: string, option: any) => {
    emit('filterChange', { value, type, id: option?.key || '' });
};

return { __sfc: true,props, emit, mandatoryFiltersConfiguration, isFilterDisabled, onFilterChange }
}

})